export class RoleInfo {
  public constructor(
    public value: string,
    public label: string,
    public isSaved: boolean = false,
    public isSelected: boolean = false,
    public isDisabled: boolean = false,
  ) {
    this.value = value;
    this.label = label;
  }
}
